import * as React from 'react';
import { Checkbox, Heading, Sheet } from '@amzn/storm-ui';
import styled from 'styled-components';
import { Container } from 'src/commons/components/Container';
import { IA2AccountDropdownFilterButton } from './IA2AccountDropdownFilterButton';
import { useAccountTypeFilter } from './useAccountTypeFilter';
import { FilterInputProps } from './IA2Types';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { ACCOUNT_TYPE_FILTER_LABEL_MAP } from './AccountTypeLocalizationKeyMapping';

const FilterInputContainer = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing.xsmall.default};
`;

const CheckBoxList = styled.div`
  display: grid;
`;

const FilterButtonContainer = styled.div`
  padding-inline-start: ${({ theme }) => theme.spacing.xsmall.default};
`;

const CheckboxContainer = styled.div<{ isFirst: boolean }>`
  ${({ isFirst }) => {
    if (isFirst) {
      return `border: 1px solid ${({ theme }) => theme.color.gray[100]};`;
    }
    return `
      border-left: 1px solid ${({ theme }) => theme.color.gray[100]};
      border-right: 1px solid ${({ theme }) => theme.color.gray[100]};
      border-bottom: 1px solid ${({ theme }) => theme.color.gray[100]};
    `;
  }}
  padding: 0 ${({ theme }) => theme.spacing.xsmall.default};
`;

export const IA2MobileAccountDropdownFilterInput: React.FC<
  FilterInputProps
> = ({ accountTypes, onSubmit }) => {
  const {
    accountTypesState,
    filteredAccountTypeCount,
    handleSubmit,
    handleOpen,
    isOpen,
    generateHandleSelection,
  } = useAccountTypeFilter({ accountTypes, onSubmit });
  const bundle = useAccountDropdownBundle();

  return (
    <>
      <FilterButtonContainer>
        <IA2AccountDropdownFilterButton
          onClick={handleOpen}
          filteredAccountTypeCount={filteredAccountTypeCount}
        />
      </FilterButtonContainer>
      <Sheet
        side="bottom"
        isOpen={isOpen}
        onClose={handleSubmit}
        sheetElementId="AACChromePortal"
        closeButton={{
          type: 'icon',
          label: 'close',
        }}
      >
        <FilterInputContainer>
          <Container>
            <Heading renderAs="h4">
              {bundle.getMessage('account-dropdown-account-types-label')}
            </Heading>
          </Container>
          <CheckBoxList>
            {accountTypesState.map((accountType, index) => {
              let label = '';
              if (ACCOUNT_TYPE_FILTER_LABEL_MAP.has(accountType.type)) {
                label = bundle.getMessage(
                  ACCOUNT_TYPE_FILTER_LABEL_MAP.get(accountType.type) as string,
                );
              }

              return (
                <CheckboxContainer isFirst={index === 0} key={accountType.type}>
                  <Checkbox
                    id={accountType.type}
                    label={label}
                    checked={accountType.isSelected}
                    onChange={generateHandleSelection(index)}
                  />
                </CheckboxContainer>
              );
            })}
          </CheckBoxList>
        </FilterInputContainer>
      </Sheet>
    </>
  );
};
